import type { CloverTerminalSaleResponseDetails } from './clover-terminal-sale-response.types';
import type { CloverTerminalSaleRequestDetails } from './clover-terminal-sale.types';

export const CloverTerminalSaleLifecyclePayloadType = {
    REQUEST: 'clover_terminal_sale_request_v1',
    RESPONSE: 'clover_terminal_sale_response_v1',
} as const;

export type CloverTerminalSaleLifecyclePayloadType =
    (typeof CloverTerminalSaleLifecyclePayloadType)[keyof typeof CloverTerminalSaleLifecyclePayloadType];

export interface CloverTerminalSaleRequestLifecyclePayload {
    readonly gateway_lifecycle_payload_type: typeof CloverTerminalSaleLifecyclePayloadType.REQUEST;
    readonly request_details: CloverTerminalSaleRequestDetails;
}

export interface CloverTerminalSaleResponseLifecyclePayload {
    readonly gateway_lifecycle_payload_type: typeof CloverTerminalSaleLifecyclePayloadType.RESPONSE;
    readonly response_details: CloverTerminalSaleResponseDetails;
}

export type CloverTerminalSaleLifecyclePayload =
    | CloverTerminalSaleRequestLifecyclePayload
    | CloverTerminalSaleResponseLifecyclePayload;
